/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://3dcegadpfj.execute-api.us-east-2.amazonaws.com/hyattolaya",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://d6loee7wc5gznlhdcmzrltzfz4.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-ew75uizfxffqng72iq756psgmm",
    "aws_cognito_identity_pool_id": "us-east-2:41bdc8d2-fe7b-4538-bc8a-c061918fa187",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_PKCwaqNlz",
    "aws_user_pools_web_client_id": "tddpo7vqhivgts8h18mr6a1jt",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
